import { render, staticRenderFns } from "./junction-box-fields-db.component.vue?vue&type=template&id=cae2042a"
import script from "./junction-box-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports